import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

interface ScanFilterState {
    locationIds: string[] | [];
    assessmentIds: string[] | [];
}

export const scanFilterState = atom<ScanFilterState>({
    key: 'scanFilterState',
    default: {
        locationIds: [],
        assessmentIds: [],
    },
    effects: [persistAtom],
});
